import axios from "axios";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

// Work orders + return-to-service (Phase 3). Creating, status changes and RTS
// are gated to owner/admin/safety server-side.
export const workOrderService = {
  getList,
  create,
  updateStatus,
  returnToService,
  destroy,
};

function getList(facilityId, status = null) {
  const params = { facility_id: facilityId };
  if (status) params.status = status;
  return axios
    .get(`${apiEndpoint.workOrders}`, { headers: authHeader(), params })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function create(payload) {
  return axios
    .post(`${apiEndpoint.workOrders}`, payload, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function updateStatus(id, status) {
  return axios
    .put(`${apiEndpoint.workOrders}/${id}/status`, { status }, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

// Authorised return-to-service: verifies the work order, closes the linked
// defect and restores the asset state.
function returnToService(id) {
  return axios
    .post(`${apiEndpoint.workOrders}/${id}/return-to-service`, {}, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function destroy(id) {
  return axios
    .delete(`${apiEndpoint.workOrders}/${id}`, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
